import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden">
          {/* Left - Image */}
          <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-[400px] overflow-hidden bg-secondary-100">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20news%20journalism%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20golden%20and%20cream%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20soft%20shadows%2C%20warm%20atmosphere&width=900&height=600&seq=cta-news&orientation=landscape"
              alt="订阅今日吃瓜"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20"></div>
            <div className="absolute top-6 left-6">
              <span className="text-xs text-white/70 font-medium tracking-wide">吃瓜前线</span>
            </div>
            <div className="absolute bottom-6 left-6">
              <p className="text-2xl md:text-3xl font-heading text-white leading-tight">
                第一时间
              </p>
              <p className="text-2xl md:text-3xl font-heading text-white/80 leading-tight">
                掌握全网爆料
              </p>
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-14 py-12 md:py-16 text-center">
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
              不想错过任何一个瓜？
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-md leading-relaxed">
              关注今日吃瓜，每日推送最新网红爆料、娱乐圈内幕、热门大瓜合集。吃瓜群众的第一选择，爆料投稿通道24小时开放。
            </p>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              了解更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}